import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const usePostCard = () => {
  const postCard = async (payload) => {
    try {
      const url = `${getApiUrl()}/mega/card`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return postCard;
};

export const useUserCard = (userId) => {
  const urlStr = `${getApiUrl()}/mega/card/${userId}`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  });
  return swr;
};
